/** @format */
import { auth } from "firemade";

export default function isAnonymous() {
  return auth.currentUser && auth.currentUser.isAnonymous ? auth.currentUser.isAnonymous : false;
}
